import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "scroll-in" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompanySearch = _resolveComponent("CompanySearch")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    max_width: "48rem",
    centered: false,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => _cache[1] || (_cache[1] = [
      _createTextVNode(" Add User Company ")
    ])),
    content: _withCtx(() => [
      _createVNode(_component_ScrollBar, {
        class: "content",
        "bar-x-offset": "0rem",
        fade: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _cache[2] || (_cache[2] = _createElementVNode("label", null, "Company", -1 /* HOISTED */)),
              _createVNode(_component_CompanySearch, {
                modelValue: $data.chosen_company,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.chosen_company) = $event)),
                "vread-from": "el_value",
                "onUpdate:el_value": $event => (($data.comp_linkedin) = $event),
                required: "",
                placeholder: "e.g. Acme",
                teleported: "",
                "user-id": $data.user_id,
                "hide-followed": true,
                disabled: $data.loading
              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:el_value", "user-id", "disabled"])
            ])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        disabled: $data.loading,
        onClick: $options.close
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_submit,
        loading: $data.loading,
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Add ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "loading", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}